import React, { useState, useEffect, useRef } from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

const DanhSachNhapHangTableRows = ({ listUserName, list, btnInNhapHangClick, btnSuaNhapHangClick, btnXoaNhapHangClick, btnPhiSanXuatClick, RoleSua, RoleXoa, RolePhiSanXuat, RoleIn }) => {
    const [showActionIndex, setShowActionIndex] = useState(null);
    const actionRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (actionRef.current && !actionRef.current.contains(e.target)) {
                setShowActionIndex(null);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    const formatPhoneNumber = (input) => {
        try {
            if (!input) return "";
            const str = input.split(';')[0].trim();
            if (str.length === 10) {
                return str.replace(/(\d{4})(\d{3})(\d{3})/, "$1.$2.$3");
            }
            if (str.length === 11) {
                return str.replace(/(\d{4})(\d{3})(\d{4})/, "$1.$2.$3");
            }
            return str;
        } catch (e) {
            return input;
        }
    }
    function parseTenTaiSanString(tenTaiSanStr) {
        if (!tenTaiSanStr) return [];
        return tenTaiSanStr
            .split('~')
            .filter(x => x.trim() !== '')
            .map(x => {
                const [TenTaiSan, Price, Status] = x.split('#');
                return {
                    TenTaiSan: TenTaiSan?.trim(),
                    Price: Number(Price) || 0,
                    Status: Number(Status) || 0,
                };
            });
    }

    return (
        <>
            {list.map((item, index) => {
                const assets = parseTenTaiSanString(item.TenTaiSan);
                return (
                    <div
                        className="custom-table-row"
                        key={item.OrderID || index}
                        style={{ minHeight: "auto"}} 
                        onClick={() => setShowActionIndex(null)}
                    >
                        <div className="custom-table-cell flex-basis-6 flex-basis-6-sm disk-mobile" style={{borderLeft: "1px solid #e3ebf3", borderRight: "1px solid #e3ebf3" }}>
                            <span className="mobile-column-name color7-bold">STT</span>
                            <div className="center-wrapper word-break" >
                                <p className="text-center color7">{item.STT}</p>
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-15-6 flex-basis-15-6-sm" style={{borderRight: "1px solid #e3ebf3" }}>
                            <span className="mobile-column-name color7-bold">Mã</span>
                            <div className="center-wrapper text-center word-break">
                                {item.OrderCode}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-15 flex-basis-15-sm" style={{ lineHeight: '1.5', borderRight: "1px solid #e3ebf3" }}>
                            <span className="mobile-column-name color7-bold">Tên khách hàng</span>
                            <div className="center-wrapper word-break">
                                {item.CustomerName}
                                {item.CustomerPhone !== "" ? (<><br />(ĐT:{formatPhoneNumber(item.CustomerPhone)})</>) : ""}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-35 flex-basis-35-sm" style={{borderRight: "1px solid #e3ebf3" }}>
                            <span className="mobile-column-name color7-bold">Tài sản</span>
                            <div className="center-wrapper word-break" style={{ padding: "10px 0", flexDirection: 'column', gap: '10px' }}> 
                                {assets.map((ts, i) => (
                                    <div key={i} style={{ display: "flex", padding: "10px", justifyContent: "center", alignItems: "center", width: '100%' }}>
                                        <p style={{ flex: 1, textAlign: "left", margin: 0 }}>{ts.TenTaiSan}</p>
                                        <p style={
                                            ts.Status === 11 ?
                                                { display: "inline-block", alignItems: "center", minHeight: "30px", minWidth: "90px", borderRadius: "10px", background: "#FFEBC6",  textAlign: "center", padding: "8px", color: "#FF5C00", } :
                                                { display: "inline-block",  alignItems: "center", minHeight: "30px", minWidth: "90px", borderRadius: "10px", background: "#CCF0EB",  textAlign: "center", padding: "8px", color: "#00B699", }}
                                        >
                                            {ts.Status === 11 ? "Chưa bán" : "Đã bán"}
                                        </p>
                                        <p style={{ flex: 1, textAlign: "right", margin: 0 }}>{formatNumber(Math.round(ts.Price))}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-13 flex-basis-13-sm" style={{ borderRight: "1px solid #e3ebf3" }}>
                            <span className="mobile-column-name color7-bold">Tiền đơn hàng</span>
                            <div className="center-wrapper text-right word-break" style={{ fontWeight: "bold",color: "#00B699", paddingRight: "10px" }}>
                                {formatNumber(Math.round(item.TotalPrice))}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-15-6 flex-basis-15-6-sm" style={{borderRight: "1px solid #e3ebf3" }}>
                            <span className="mobile-column-name color7-bold">Số tiền còn lại</span>
                            <div className="center-wrapper color-do-bold text-right word-break" style={{ paddingRight: "10px"}}>
                                {formatNumber(Math.round(item.TotalAmount))}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-11 flex-basis-11-sm" style={{borderRight: "1px solid #e3ebf3", borderBottom:"1px solid #e3ebf3" }}>
                            <span className="mobile-column-name color7-bold">Nhân viên</span>
                            <div className="center-wrapper text-center word-break">
                                {(() => {
                                    const user = listUserName.find(u => u.value === item.CreatedUser);
                                    return user ? user.label : "" || "";
                                })()}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-9 flex-basis-9-sm" style={{ borderRight: "1px solid #e3ebf3", borderBottom:"1px solid #e3ebf3" }}>
                            <span className="mobile-column-name color7-bold">Thời gian</span>
                            <div className="center-wrapper text-center word-break">
                                {getDate(item.CreatedDate)}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm word-break" style={{ justifyContent: "center", position: "relative", borderRight: "1px solid #e3ebf3", borderBottom:"1px solid #e3ebf3" }}>
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }} >
                                {RoleIn && (
                                    <a
                                        className="iconTableMorman"
                                        title="In phiếu nhập hàng"
                                        onClick={() => btnInNhapHangClick(item.OrderID)}
                                    >
                                        <img src="/app-assets/images/icon-in-danh-sach.png" />
                                    </a>
                                )}
                                {RolePhiSanXuat && (
                                    <a
                                        className="iconTableMorman"
                                        title="Phí sản xuất"
                                        onClick={() => btnPhiSanXuatClick(item.OrderID)}
                                    >
                                        <img src="/app-assets/images/icon-dolla-v2.png" alt="Phí sản xuất" />
                                    </a>
                                )}
                                <img src="/app-assets/images/icon-more.png" className="more-icon" style={{ width: "20px", height: "20px", cursor: "pointer" }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setShowActionIndex((prev) =>
                                            prev === index ? null : index
                                        );
                                    }} />
                                {showActionIndex === index && (
                                    <>
                                        <div
                                            className="action-buttons"
                                            style={{
                                                display: "flex",
                                                gap: "8px",
                                                marginTop: "0px",
                                                flexDirection: "column",
                                                background: "#fff",
                                                borderRadius: "6px",
                                                padding: "4px 6px",
                                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                                position: "absolute",
                                                top: "70%",
                                                right: "15px",
                                                zIndex: 9999,
                                            }}
                                        >
                                            {RoleSua && (
                                                <a
                                                    className="iconTableMorman"
                                                    title="Sửa"
                                                    onClick={() => btnSuaNhapHangClick(item.OrderID)}
                                                >
                                                    <img src="/app-assets/images/icon-button-edit-v2.png" />
                                                    &nbsp; <span className="color7-bold">Sửa</span>
                                                </a>
                                            )}
                                            {RoleXoa && item.IsDeletable === true && (
                                                <a
                                                    className="iconTableMorman"
                                                    title="Xóa"
                                                    onClick={() => btnXoaNhapHangClick(item.OrderID)}
                                                >
                                                    <img src="/app-assets/images/icon-xoa-v2.png" />
                                                    &nbsp; <span className="color7-bold">Xóa</span>
                                                </a>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                )
            })}
        </>)
};
const DanhSachNhapHangTable = ({ listUserName, list, Total, TotalPrice, TotalAmount, TotalConLai, btnInNhapHangClick, btnSuaNhapHangClick, btnXoaNhapHangClick, btnPhiSanXuatClick, RoleSua, RoleXoa, RolePhiSanXuat, RoleIn }) => {
    if (!list || list.length === 0) {
        return (
            <div className="custom-table-row">
                <div className="custom-table-cell text-center red" style={{ width: "100%" }}>
                    Không có dữ liệu
                </div>
            </div>
        );
    }

    return (<>
        <div className="Left808x200 Table-main-new ">
            <div className="table-mobile sticky-table-bh2 table-mobile-hover">
                <div className="custom-table-wrapper" style={{ overflowX: 'auto'}}>
                    <div className="table-headers  hidden-mobile-main word-break" style={{alignItems: 'stretch'}}> 
                        <div className="custom-table-header text-center flex-basis-6 flex-basis-6-sm disk-mobile" style={{borderLeft: "1px solid #e3ebf3", borderRight: "1px solid #e3ebf3" }}>
                            <p className="">
                                STT
                                <br />
                                <span className="color-do-bold">[{Total ? Total : 0}]</span>
                            </p>
                        </div>
                        <div className="custom-table-header flex-basis-15-6 flex-basis-15-6-sm" style={{ textAlign: "center",borderRight: "1px solid #e3ebf3" }}>
                            <p>Mã</p>
                        </div>
                        <div className="custom-table-header flex-basis-15 flex-basis-15-sm" style={{borderRight: "1px solid #e3ebf3" }}>
                            <p>Tên khách hàng
                            </p>
                        </div>
                        <div className="custom-table-header flex-basis-35 flex-basis-35-sm" style={{ textAlign: "center", borderRight: "1px solid #e3ebf3" }}>
                            <p>Tài sản
                                <br />
                                <span className="color-do-bold" style={{ fontSize: "12px" }}>{TotalPrice ? formatNumber(Math.round(TotalPrice)) : 0}</span>
                            </p>
                        </div>
                        <div className="custom-table-header text-right flex-basis-13 flex-basis-13-sm" style={{ textAlign: "right", paddingRight: "10px",  borderRight: "1px solid #e3ebf3" }} >
                            <p>
                                Tiền đơn hàng
                                <br />
                                <span style={{ fontWeight: "bold", fontSize: "12px", color: "#00B699", }}>{TotalAmount ? formatNumber(Math.round(TotalAmount)) : 0}</span>
                            </p>
                        </div>
                        <div className="custom-table-header text-right flex-basis-15-6 flex-basis-15-6-sm" style={{ textAlign: "right", paddingRight: "10px", borderRight: "1px solid #e3ebf3" }}>
                            <p>
                                Số tiền còn lại
                                <br />
                                <span className="color-do-bold" style={{ fontSize: "12px" }}>{TotalConLai ? formatNumber(Math.round(TotalConLai)) : 0}</span>
                            </p>
                        </div>
                        <div className="custom-table-header text-center flex-basis-11 flex-basis-11-sm" style={{ textAlign: "center", borderRight: "1px solid #e3ebf3" }} >
                            <p>
                                Nhân viên
                            </p>
                        </div>
                        <div className="custom-table-header text-center flex-basis-9 flex-basis-9-sm" style={{ textAlign: "center",  borderRight: "1px solid #e3ebf3" }}>
                            <p>
                                Thời gian
                            </p>
                        </div>
                        <div className="custom-table-header text-center flex-basis-10 flex-basis-10-sm" style={{ textAlign: "center", borderRight: "1px solid #e3ebf3" }}>
                            <p>Thao tác</p>
                        </div>
                    </div>
                    <div className="custom-table-body">
                        <DanhSachNhapHangTableRows
                            listUserName={listUserName}
                            list={list}
                            btnSuaNhapHangClick={btnSuaNhapHangClick}
                            btnInNhapHangClick={btnInNhapHangClick}
                            btnXoaNhapHangClick={btnXoaNhapHangClick}
                            btnPhiSanXuatClick={btnPhiSanXuatClick}
                            RoleSua={RoleSua}
                            RoleXoa={RoleXoa}
                            RolePhiSanXuat={RolePhiSanXuat}
                            RoleIn={RoleIn}
                        />
                    </div>
                </div>
            </div>
        </div>
    </>)
};

export default DanhSachNhapHangTable;  